import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import Paper from "@mui/material/Paper";

import Placeholder from "components/Placeholder";
import ParkkiTheme from "themes/ParkkiTheme";
import Slider from "components/Slider";

const StyledPaper = styled(Paper)`
  height: 120px;
  padding-right: 35px;
`;

const Container = styled.div`
  margin-left: ${ParkkiTheme.spacings.large};
  margin-right: ${ParkkiTheme.spacings.large};
  padding-top: 55px;
`;

const CustomSlider = styled(Slider)`
  .MuiSlider-rail {
    /* Rail, toute la longueur */
    height: 4px;
  }
  .MuiSlider-track {
    /* Rail, parti de gauche */
    height: 4px;
    width: ${({ mainValue }) => `${mainValue}% !important`};
  }
  .Mui-disabled,
  .MuiSlider-track {
    /* Rail, partir de gauche */
    color: rgb(33, 149, 164);
  }

  .MuiSlider-mark {
    /* Ligne du bout à droite */
    width: 1px;
    height: 8px;
    background-color: ${ParkkiTheme.colors.disabledGrey};
    background-color: #00000061;
    margin-top: 0px;
    margin-left: 0px;
    opacity: 1;
  }

  .MuiSlider-markLabel {
    /* Label de droite "20 visiteurs" */
    color: ${ParkkiTheme.colors.disabledGrey};
  }

  .MuiSlider-thumb {
    /* Cercle avec le label "30%" */
    height: 24px;
    width: 24px;
    margin-top: -29px;
    height: 0px;
  }

  span[data-index="0"] {
    /* Premier cercle "0%" */
    span {
      opacity: 0;
    }
  }

  /* Indicateur des seuils */
  span.MuiSlider-thumb {
    & .MuiSlider-valueLabel {
      transform-origin: bottom left;
      transform: translate(50%) rotate(-45deg) !important;

      width: 32px;
      height: 32px;
      font-size: 12px;
      font-weight: 400;
      padding: 0;
      background: unset;
      border-radius: 50% 50% 50% 0;
      background-color: ${ParkkiTheme.colors.disabledGrey};

      &:before {
        display: none;
      }
      & > * {
        transform: rotate(45deg);
      }
    }
  }

  /* Indicateur de la valeure courante */
  span[${({ valueIndex }) => `data-index="${valueIndex}"`}] {
    & .MuiSlider-valueLabel {
      transform-origin: bottom left;
      transform: translate(50%) rotate(-45deg) !important;

      width: 32px;
      height: 32px;
      font-size: 12px;
      font-weight: 400;
      padding: 0;
      background: unset;
      border-radius: 50% 50% 50% 0;
      background-color: rgb(33, 149, 164);

      &:before {
        display: none;
      }
      & > * {
        transform: rotate(45deg);
      }
    }
  }
`;

const StyledSection = styled.div`
  margin-top: 16px;
`;

function valuetext(value) {
  return `${value || 0}%`;
}

function StatsSlider({ initialized, stats }) {
  if (!initialized) {
    return (
      <StyledSection>
        <Placeholder height="120px" delay={0} />
      </StyledSection>
    );
  }
  if (!stats) {
    return null;
  }

  const [value] = stats.data.slice(-1);

  return (
    <StyledPaper>
      <Container>
        <CustomSlider
          disabled
          valueLabelDisplay="on"
          defaultValue={stats?.data}
          mainValue={stats?.mainValue > 100 ? 100 : stats?.mainValue}
          valueIndex={stats?.data?.indexOf(stats?.mainValue)}
          valueLabelFormat={valuetext}
          marks={stats.marks}
          sliderValue={value}
          max={stats?.mainValue > 100 ? stats?.mainValue : 100}
        />
      </Container>
    </StyledPaper>
  );
}

StatsSlider.propTypes = {
  initialized: PropTypes.bool.isRequired,
};
export default StatsSlider;
